<template>
  <div class="bb-upload" @mouseleave="closePopup()" @mouseenter="mouseReturn = true">
    <div class="bb-upload-popup-wrapper" @click.stop="popupOpen($event)" v-if="files && files.length > 0">
      <img class="bb-upload__icon" ref="uploadPopup" :src="documentIcon" v-if="allUploaded"
           :class="{'bb-upload__icon_large': sizeIcon === 'large'}"/>
      <div v-else class="bb-upload-popup-item-loading">
        <div class="bb-upload-popup-item-loading__container">
          <span class="bb-upload-popup-item-loading__loader"/>
        </div>
      </div>
      <transition name="bounce">
        <div class="bb-upload-popup"
             :class="{
               'bb-upload-popup_up': !popupDown,
               'bb-upload-popup_right': index < 3
             }"
             :style="popupPosition"
             v-if="openPopup"
             v-click-outside="closePopup">
          <div v-for="(file) in files" :key="file.id" class="bb-upload-popup-item">
            <p class="bb-upload-popup-item__name" @click.stop="getFile(file)" v-if="view">
              {{file.label}}
            </p>
            <i class="icon-cross bb-upload-popup-item__delete"
               @click.stop="deleteFile(file.id)"
               v-if="file.path && (upload || displayDelete)"/>
            <div v-else-if="upload" class="bb-upload-popup-item-loading">
              <div class="bb-upload-popup-item-loading__container">
                <span class="bb-upload-popup-item-loading__loader"/>
              </div>
            </div>
          </div>
          <div class="bb-upload-popup-item bb-upload-popup-item_upload" :class="{'shake': wrongFormat}" v-if="upload">
            <p class="bb-upload-popup-item__name">
              Upload File
            </p>
            <img class="bb-upload__icon bb-upload-popup-item__delete" src="@/assets/images/icon-download.png"/>
            <template v-if="multiple">
              <input class="bb-upload__input" type="file" @change="previewFiles" multiple>
            </template>
            <template v-else>
              <input class="bb-upload__input" type="file" @change="previewFiles" >
            </template>
          </div>
        </div>
      </transition>
    </div>
    <div class="bb-upload-popup-item bb-upload-popup-item__icon" :class="{'shake': wrongFormat}" v-else>
      <img class="bb-upload__icon bb-upload-popup-item__delete" src="@/assets/images/icon-download.png"/>
      <template v-if="multiple">
        <input class="bb-upload__input" type="file" @change="previewFiles" multiple>
      </template>
      <template v-else>
        <input class="bb-upload__input" type="file" @change="previewFiles">
      </template>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import eye from '@/assets/images/icon-eye.png'
export default {
  name: 'Upload',
  props: ['view', 'upload', 'item', 'fixed', 'displayDelete', 'multiple', 'files', 'popupDown', 'iconView', 'index'],
  data () {
    return {
      wrongFormat: false,
      openPopup: false,
      mouseReturn: false,
      popupPosition: {}
    }
  },
  computed: {
    sizeIcon () {
      return this.iconView ? 'large' : 'default'
    },
    documentIcon () {
      return this.iconView ? this.iconView : eye
    },
    allUploaded () {
      const files = this.files || []
      return _.every(files, item => item.path)
    }
  },
  methods: {
    previewFiles (event) {
      this.$emit('upload', event.target.files, this.item)
      event.target.value = ''
    },
    deleteFile (fileId) {
      this.$emit('delete', fileId, this.item)
    },
    getFile (file) {
      if (!file.path) return
      this.openPopup = false
      this.$emit('view', file, this.item)
    },
    popupOpen (e) {
      this.openPopup = !this.openPopup
      if (this.fixed) {
        this.setPositionPopup(e)
      }
    },
    setPositionPopup (e) {
      const box = e.target.getBoundingClientRect()
      const popups = _.get(this.$refs, 'uploadPopup', '')
      const popupWidth = _.get(popups, 'offsetWidth', 0)
      this.popupPosition = {
        position: 'fixed',
        left: (box.left - popupWidth - box.width) + 'px',
        right: 'auto',
        top: box.top + 30 + 'px'
      }
    },
    closePopup () {
      this.mouseReturn = false
      _.delay(() => {
        if (!this.mouseReturn) {
          this.openPopup = false
          this.mouseReturn = false
        }
      }, 500)
    }
  },
  watch: {
    allUploaded (newVal) {
      this.$emit('statusUpload', !newVal)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-upload {
    position: relative;
    cursor: pointer;
    user-select: none;

    &-popup-wrapper {
      width: 21px;
      height: 21px;
      position: relative;
    }

    &-popup {
      font-weight: 300;
      font-size: 13px;
      position: absolute;
      right: 0;
      top: 30px;
      padding: 12px 12px 0;
      box-shadow: 0 0 20px rgba($color-black, 0.05);
      background: $color-white;
      border-radius: 5px;
      min-width: 75px;
      z-index: 26;

      &:after{
        content: '';
        position: absolute;
        right: 7px;
        bottom: 100%;
        width: 0;
        height: 0;
        border-left: 3px solid transparent;
        border-right: 3px solid transparent;
        border-bottom: 5px solid $color-white;
        box-shadow: 0 0 20px rgba($color-black, 0.1);
        clear: both;
      }

      &_right {
        right: auto;
        left: 0;

        &:after {
          left: 7px;
        }
      }

      &_up {
        top: auto;
        bottom: 31px;

        &:after{
          top: 100%;
          border-left: 3px solid transparent;
          border-right: 3px solid transparent;
          border-top: 5px solid $color-white;
          border-bottom: none;
        }
      }

      &-item {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        white-space: nowrap;
        margin-bottom: 12px;
        transition: .3s;

        &__icon {
          margin-bottom: 0;
        }

        &_upload {
          &:hover {
            opacity: 0.6;
          }
        }

        &__name {
          margin-right: 10px;
          transition: .3s;

          &:hover {
            opacity: 0.6;
          }
        }

        &__delete {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 20px;
          width: 20px;
          color: $color-silver-chalice;
          border-radius: 2px;
          transition: .3s;

          &:hover {
            color: $color-dusty-gray;
            background-color: $color-wild-sand;
          }
        }

        &-loading {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 21px;
          height: 21px;
          border-radius: 50%;
          background-color: $color-wild-sand;

          &__container {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            border: 1px solid $color-navy-blue;
            box-sizing: border-box;
            border-radius: 16px;
            width: 15px;
            height: 5px;
          }

          &__loader {
            background-color: $color-navy-blue;
            width: 50%;
            height: 100%;
            transition: .3s;
            animation: file-upload 3s linear infinite;
          }
        }

      }
    }

    &__icon {
      width: 21px;
      height: 21px;

      &_large {
        margin-top: -4px;
        margin-left: -10px;
        width: 25px;
        height: 25px;
      }
    }

    &__input {
      position: absolute;
      top:0;
      left: 0;
      width: 100%;
      height: 21px;
      opacity: 0;
      padding: 21px 21px 0 0;
      cursor: pointer;
    }
  }

  @keyframes shake {
    from,
    to {
      transform: translate3d(0, 0, 0);
    }

    20%,
    60% {
      transform: translate3d(-3px, 0, 0);
    }

    40%,
    80% {
      transform: translate3d(3px, 0, 0);
    }
  }

  @keyframes file-upload {
    from {
      width: 0;
    }

    to {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/Upload/Upload.vue